import { ALL_FONT_FAMILY_OPTIONS } from 'components/editor/grid/reduxStore/defaultTextDefaultValue';

export interface FontOption {
  name: string;
  value: string;
}

/**
 * Convert editor font format to select dropdown format with proper CSS font-family values.
 * Merges base fonts with any custom fonts, deduplicating by name.
 */
export const getFontFamilyOptions = (customFonts: Array<{ name: string }> = []): FontOption[] => {
  const merged = [...ALL_FONT_FAMILY_OPTIONS, ...customFonts];
  const unique = Array.from(new Map(merged.map((f) => [f.name, f])).values());
  return unique.map((font) => ({ name: font.name, value: font.name }));
};

export const toCssFontFamily = (name: string): string => {
  // Only for UI rendering (labels/items), not for persistence
  if (!name) return '';
  return /[\s,]/.test(name) ? `"${name}"` : name;
};
